import m from "mithril"
import { state } from "../state/store.js"
import logo from "../assets/logo.svg"

function toggleMobileNav() {
  state.mobileNavOpen = !state.mobileNavOpen
  document.body.style.overflow = state.mobileNavOpen ? "hidden" : ""
}

export default {
  view: function () {
    return m("header.header", [
      m(m.route.Link, { href: "/", class: "logo, flex flex-row justify-center items-center" }, [
        m("img", { class: "pr-2", src: logo, alt: "Mark Logo", style: "height: 40px; width: auto; fill: currentColor;" }),
        m('span', "MARK'S PERSONAL WEBSITE"),
      ]),
      m("nav.nav", [
        m("a.nav-link.active", { href: "#portfolio" }, "Portfolio"),
        m("a.nav-link", { href: "#portfolioGrid" }, "Experiment"),
        m("a.nav-link", { href: "#contact" }, "Contact"),
      ]),
      m("button.menu-toggle", {
        class: state.mobileNavOpen ? "active" : "",
        "aria-label": "Toggle menu",
        onclick: toggleMobileNav,
      }, [
        m("span"),
        m("span"),
        m("span"),
      ]),
    ])
  },
}
